"use client";
import handleScroll from "@/utils/handleScroll";
import Link from "next/link";
import React from "react";
import { GoTriangleDown } from "react-icons/go";

interface ScrollDownButtonProps {
    scrollToId: string;
    offset?: number;   
}

const ScrollDownButton = ({scrollToId, offset}: ScrollDownButtonProps) => {
  return (
    <div className="scroll-down-button">
      <Link href="#" onClick={(event) => handleScroll(event, scrollToId, offset || 0)}>
        <GoTriangleDown className="scroll-down-icon" />
      </Link>
    </div>
  );
};

export default ScrollDownButton;
